import { Button, Card, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { ReactElement, useContext } from "react";
import SearchProvider, { SearchContexts } from "pages/Search/View/Main/store"
import { updateItem } from "pages/Search/View/Main/action"
import { fetchData, useInit } from "pages/Search/View/Main/logic"
import { useStyles } from "./logic"

function Page(): ReactElement {
    const { updateInputData } = useInit()
    const classes = useStyles()
    const { dispatch, state } = useContext(SearchContexts)
    const { busts, heights, minBust, maxBust, minHeight, maxHeight, minBirthday, maxBirthday, keyword, actress } = state
    console.log(minBust, maxBust, minHeight, maxHeight, minBirthday, maxBirthday, keyword, actress)

    return (
        <div style={{ margin: "0 auto", width: "100%" }}>
            <div style={{ display: "grid", gridGap: "10px", justifyContent: "center", alignItems: "center", gridTemplateColumns: "100px 100px 100px 100px 200px 200px 200px 100px" }}>
                <FormControl style={{ width: "100px", textAlign: "center" }}>
                    <InputLabel style={{ textAlign: "center" }}>B-min</InputLabel>
                    <Select
                        value={minBust}
                        // onChange={e => dispatch(updateItem({ item: 'minBust', value: String(e.target.value) }))}
                        onChange={e => updateInputData('minBust', String(e.target.value))}
                    >
                        {busts.map(bust =>
                            <MenuItem value={bust}>{bust}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControl style={{ width: "100px", textAlign: "center" }}>
                    <InputLabel style={{ textAlign: "center" }}>B-max</InputLabel>
                    <Select
                        value={maxBust}
                        onChange={e => dispatch(updateItem({ item: 'maxBust', value: String(e.target.value) }))}
                    >
                        {busts.map(bust =>
                            <MenuItem value={bust}>{bust}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControl style={{ width: "100px", textAlign: "center" }}>
                    <InputLabel style={{ textAlign: "center" }}>H-min</InputLabel>
                    <Select
                        value={minHeight}
                        onChange={e => dispatch(updateItem({ item: 'minHeight', value: String(e.target.value) }))}
                    >
                        {heights.map(age =>
                            <MenuItem value={age}>{age}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControl style={{ width: "100px", textAlign: "center" }}>
                    <InputLabel style={{ textAlign: "center" }}>H-max</InputLabel>
                    <Select
                        value={maxHeight}
                        onChange={e => dispatch(updateItem({ item: 'maxHeight', value: String(e.target.value) }))}
                    >
                        {heights.map(age =>
                            <MenuItem value={age}>{age}</MenuItem>
                        )}
                    </Select>
                </FormControl>
                <TextField
                    label="birthday-min"
                    type="date"
                    defaultValue={minBirthday}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={minBirthday}
                    onChange={(e) => dispatch(updateItem({ item: 'minBirthday', value: String(e.target.value) }))}
                />
                <TextField
                    label="birthday-max"
                    type="date"
                    defaultValue={maxBirthday}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    value={maxBirthday}
                    onChange={(e) => dispatch(updateItem({ item: 'maxBirthday', value: String(e.target.value) }))}
                />
                <TextField id="outlined-basic" label="keyword" variant="outlined" size="small" value={keyword}
                    onChange={(e) => dispatch(updateItem({ item: 'keyword', value: e.target.value }))}
                />
                <Button variant="contained" onClick={() => fetchData(dispatch, state)}>Search</Button>
            </div>
            <div className={classes.cardInfoErea}>
                {actress.map((record, index) => (
                    <Card className={classes.card} key={index}>
                        <a href={record.listURL} target="_blank" rel="noreferrer noopener" className={classes.img}>
                            <img className={classes.img} src={record.imageURL} alt={record.name} />
                        </a>
                        <Card>
                            <ul className={classes.cardInfo}>
                                <li><a className={classes.link} href={record.listURL} target="_blank" rel="noreferrer noopener">{index + 1}.{record.name}</a></li>
                                <li>birthday : {record.birthday ? record.old + '(' + record.birthday + ')' : null}</li>
                                <li>ruby : {record.ruby}</li>
                                <li>bust : {record.bust}</li>
                                <li>waist : {record.waist}</li>
                                <li>hip : {record.hip}</li>
                                <li>height : {record.height}</li>
                            </ul>
                        </Card>
                    </Card>
                )
                )}
            </div>
        </div>
    )
}

function parent() {
    return (
        <SearchProvider>
            <Page />
        </SearchProvider>
    )
}

export default parent;


